import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { useQuery } from '@apollo/client';
import * as HistoricalSeasonsQuery from '../../core/gql/queries/historical-seasons';
import SeasonCard from 'components/season/season-card';
import './seasons.scss';

export interface Props extends RouteComponentProps<any> {}

const HistoricalSeasons: React.FunctionComponent<Props> = ({
  match: {
    params: { orgId },
  },
}) => {
  const { data, loading } = useQuery(HistoricalSeasonsQuery.QUERY, { variables: { organizationId: +orgId } });

  if (!orgId) return null;
  if (loading) return null;

  const historicalSeasons = data?.historicalSeasons;

  return (
    <div id="seasons" className="container">
      <div className="page-content page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1>Historical Seasons </h1>
            <p>This program holds all historical seasons created on the old version of the product before upgrading.</p>
          </div>
          <div className="Grid-cell u-xs-size1of2 u-textRight"></div>
        </div>
        <div className="page-content-body">
          {historicalSeasons.map((season) => (
            <SeasonCard
              key={season.id}
              season={season}
              programName="Historical Seasons"
              canUserDeleteSeason={false}
              organizationId={+orgId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HistoricalSeasons;
